import { render, staticRenderFns } from "./InvoiceRecordDetail.vue?vue&type=template&id=70d9b06e&scoped=true&"
import script from "./InvoiceRecordDetail.vue?vue&type=script&lang=js&"
export * from "./InvoiceRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceRecordDetail.vue?vue&type=style&index=0&id=70d9b06e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d9b06e",
  null
  
)

component.options.__file = "InvoiceRecordDetail.vue"
export default component.exports